import { useInfiniteQuery } from '@tanstack/react-query';
import { fetchAllAliases } from '../services/AdministrationService';

export const useAllAliases = () => {
    const query = useInfiniteQuery({
        queryKey: ['admin', 'aliases'],
        queryFn: ({ pageParam }: { pageParam: string | null }) => 
            fetchAllAliases({ limit: 10, nextToken: pageParam }),
        getNextPageParam: (lastPage) => lastPage?.nextToken || undefined,
        initialPageParam: null as string | null
    });

    const allItems = query.data?.pages?.flatMap(page => page?.items || []) || [];

    return {
        items: allItems,
        visibleItems: allItems,
        visibleCount: allItems.length,
        loading: query.isLoading,
        nextToken: query.hasNextPage ? 'has-more' : null,
        isFetchingNextPage: query.isFetchingNextPage,
        fetchRecords: () => {
            if (query.hasNextPage) {
                query.fetchNextPage();
            }
        }
    };
};
